import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Collection, Roles } from 'constants/index'
import firebase from 'firebase/app'
import { toast } from 'react-toastify'

export const initialState = {
  error: null,
  inProgress: false,
  user: null,
  isAuthenticated: false,
  isDarkTheme: false
}

export const signOut = createAsyncThunk(
  'user/signOut',
  async (requestData, { rejectWithValue }) => {
    try {
      await firebase.auth().signOut()
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload
    },
    setDarkTheme: (state, action) => {
      state.isDarkTheme = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.user = null
      state.isAuthenticated = false
      state.isDarkTheme = false
    }
  }
})

export const signIn = (email, password) => async (dispatch) => {
  try {
    const response = await firebase.auth().signInWithEmailAndPassword(email, password)
    const user = {
      id: response.user.uid,
      email: response.user.email
    }
    const userSnapshot = await firebase.firestore().collection(Collection.USERS).doc(user.id).get()
    const userResponse = userSnapshot.data()

    if (userResponse.role === Roles.ADMIN) {
      const confSnapshot = await firebase
        .firestore()
        .collection(Collection.CONFERENCES)
        .doc(userResponse.conferenceId)
        .get()

      const confResponse = confSnapshot.data()

      if (!confResponse.isActive) {
        dispatch(
          authSlice.actions.setError('You cannot login because your Conference is disabled.')
        )
      } else {
        dispatch(authSlice.actions.setUser({ ...user, ...userResponse }))
        dispatch(authSlice.actions.setAuthenticated(true))
        return { ...user, ...userResponse }
      }
    } else {
      dispatch(authSlice.actions.setUser({ ...user, ...userResponse }))
      dispatch(authSlice.actions.setAuthenticated(true))
      return { ...user, ...userResponse }
    }
  } catch (err) {
    toast.error('Incorrect Email or Password, Please try again.')
    return null
  }
}

export default authSlice
